// Perguntas do termo das crianças: o aceite é só pelo link dos pais,
// então elas não aparecem na ficha que a pessoa preenche ou edita.
const CHAVES_DO_TERMO = ['filhos_termo', 'filhos_termo_registro'];

export function ehPerguntaDoTermo(chave?: string | null): boolean {
  if (!chave) return false;
  return CHAVES_DO_TERMO.includes(chave.trim());
}

function preenchido(valor: unknown): boolean {
  if (valor === null || valor === undefined) return false;
  if (typeof valor === 'boolean') return valor;
  if (Array.isArray(valor)) return valor.length > 0;
  const texto = String(valor).trim().toLowerCase();
  if (!texto) return false;
  return texto !== 'false' && texto !== 'nao' && texto !== 'não';
}

/**
 * A pessoa marcou que vai levar filhos?
 * Vale qualquer resposta ligada a filhos (menos as do termo).
 */
export function marcouFilhos(
  itens: { chave?: string | null; valor: unknown }[],
): boolean {
  return itens.some((item) => {
    const chave = item.chave?.trim();
    if (!chave || ehPerguntaDoTermo(chave)) return false;
    if (!/filho/i.test(chave)) return false;
    return preenchido(item.valor);
  });
}